import { getMapTileHosts } from '../config/mapTiles.js';

/**
 * Registra el service worker que cachea los tiles del mapa (public/map-tile-sw.js).
 *
 * El caché HTTP del navegador ya guarda tiles, pero se desaloja seguido y no
 * sobrevive bien entre sesiones. Este SW los deja en Cache Storage, así el mapa
 * pinta al instante en visitas repetidas y aguanta cortes de red.
 *
 * Los hosts del proveedor viajan en el query string: el SW no conoce ningún
 * proveedor, solo intercepta lo que se le indica acá.
 */
export const registerMapTileCache = () => {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;

  const hosts = getMapTileHosts();
  if (hosts.length === 0) return;

  // Registrar después del load para no competir con el arranque de la app.
  window.addEventListener('load', () => {
    const url = `/map-tile-sw.js?hosts=${encodeURIComponent(hosts.join(','))}`;
    navigator.serviceWorker.register(url).catch((error) => {
      // El mapa funciona igual sin caché: no hay que romper el arranque por esto.
      console.warn('No se pudo registrar el caché de tiles del mapa:', error);
    });
  });
};

/** Vacía el caché de tiles. Útil al cambiar de proveedor de mapa. */
export const clearMapTileCache = async () => {
  if (typeof caches === 'undefined') return;
  const names = await caches.keys();
  await Promise.all(
    names.filter((name) => name.startsWith('map-tiles-')).map((name) => caches.delete(name))
  );
};
